import tw, { TwStyle } from 'twin.macro';

const colors = ['gray', 'gray-light', 'indigo', 'indigo-light', 'blue', 'yellow', 'red', 'red-light', 'green'] as const;

export type Color = (typeof colors)[number];

export const calculateColor = (input: string): Color => {
	const blacklistedColors = ['indigo-light', 'red-light', 'gray-light'];

	const value = input.split('').reduce((carry, char) => (carry += char.charCodeAt(0)), 0);
	const filteredColors = colors.filter((color) => !blacklistedColors.includes(color));

	return filteredColors[value % filteredColors.length];
};

export const getColorStyles = (color?: Color): TwStyle => {
	switch (color) {
		case 'gray':
			return tw`bg-gray-500 hcontrast:bg-gray-700`;
		case 'gray-light':
			return tw`bg-gray-400 hcontrast:bg-gray-100`;
		case 'indigo-light':
			return tw`bg-indigo-300 hcontrast:bg-indigo-700`;
		case 'indigo':
			return tw`bg-indigo-500 hcontrast:bg-indigo-700`;
		case 'blue':
			return tw`bg-blue-500 hcontrast:bg-blue-700`;
		case 'yellow':
			return tw`bg-yellow-500 hcontrast:bg-yellow-700`;
		case 'red-light':
			return tw`bg-red-300 hcontrast:bg-red-100`;
		case 'red':
			return tw`bg-red-500 hcontrast:bg-red-700`;
		case 'green':
			return tw`bg-green-500 hcontrast:bg-green-700`;
		default:
			return tw`bg-indigo-500 hcontrast:bg-indigo-700`;
	}
};
